import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import eulabg from '../assets/images/eula.jpg';

function EULA(){

    useEffect(() => {
          document.title = "DCode | Eula";
        }, []);
   
    return(
        <div>
            <Hero bgimg={eulabg} content="Everything you need to know about how DCode works, your rights, limitations, and responsibilities as a user is detailed below.  " title="End User License Aggrement"/>
                <section id="faq">
      <div className="container">
       <h1 className="faq-h1" style={{fontSize:"24PX", textAlign:"left"}}>
        EULA - DCode
       </h1>
       
            <h5>
                Effective Date: July 25, 2025
            </h5>
            <p className="eula-p">
                This End User License Agreement ("Agreement") is a legal agreement between you ("User", "you", or "your") and Designite ("Company", "we", "us", or "our") governing your access to and use of our online platform <a className="eula-link" href="https://www.dcodehub.com">https://www.dcodehub.com</a> (the "Platform"), which provides services including but not limited to storing code analysis summaries and productivity metrics of analyzed software projects.
            </p>
            <p className="eula-p">
                By accessing or using the platform, you agree to be bound by this Agreement. If you do not agree with any of the terms herein, do not access or use the platform.
            </p>

            <ol>
         
                <li>
                    
                       <strong className="eula-li">LICENSE GRANT</strong> 

                        <p className="eula-p">
                            Subject to your compliance with this Agreement, the Company grants you a limited, non-exclusive, non-transferable, revocable license to access and use the platform for your internal use.
                        </p>
                    
                </li>

                <li>
                    
                       <strong className="eula-li">SERVICES</strong> 

                        <p className="eula-p">
                            The platform offers functionality including uploading and storing source code analysis summaries either manually or automatically, viewing productivity metrics and trends across analyzed projects, generating reports and insights, and managing analysis configurations and results.
                        </p>

                        <p className="eula-p">
                            Some features may require a valid paid license or subscription plan ("Licensed Services"). We reserve the right to modify, suspend, or discontinue any part of the platform at any time with or without notice.
                        </p>
                    
                </li>

                <li>
                    
                       <strong className="eula-li">USER CONTENT</strong> 

                        <p className="eula-p">
                            You retain ownership of all artifacts and data you upload ("User Content"). However, by using the platform, you grant the Company a worldwide, non-exclusive, royalty-free license to use, store, process, and analyze the User Content solely to provide the services described herein, improve our services, and conduct research (in anonymized and aggregated form).
                        </p>

                        <p className="eula-p">
                            You are solely responsible for the content you upload and must ensure you have all necessary rights to do so.
                        </p>
                    
                </li>

                 <li>
                    
                       <strong className="eula-li">FEES AND PAYMENT</strong> 

                        <p className="eula-p">
                            Access to certain features may require payment of a license fee or subscription charge. You agree to pay all applicable fees as presented to you at the time of purchase, in accordance with the pricing and terms. Fees are non-refundable except as required by law or expressly stated in our refund policy.
                        </p>
                </li>

                 <li>
                    
                       <strong className="eula-li">RESTRICTIONS</strong> 

                        <p className="eula-p">
                            You agree not to:
                            <ul>
                                <li>
        Copy, modify, distribute, sell, or lease any part of the platform;
                                </li>
                                 <li>
        Reverse engineer or attempt to extract the source code of the platform;
                                </li>
                                 <li>
       Use the platform for unlawful or unauthorized purposes;
                                </li>
                                 <li>
        Interfere with the security or integrity of the Platform or others' data.
                                </li>
                            </ul>

                        </p>
                </li>

                <li>
                    
                       <strong className="eula-li">INTELLECTUAL PROPERTY</strong> 

                        <p className="eula-p">
                            All rights, title, and interest in and to the platform (excluding User Content) are and will remain the exclusive property of the Company and its licensors. The Company name, logo, and other associated marks are trademarks of the Company and may not be used without permission.
                        </p>
                </li>

                 <li>
                    
                       <strong className="eula-li">PRIVACY AND DATA USE</strong> 

                        <p className="eula-p">
                            Our Privacy Policy governs our handling of personal and project-related data. By using the platform, you agree to the collection and use of information in accordance with our Privacy Policy.
                        </p>
                </li>

                <li>
                    
                       <strong className="eula-li">TERMINATION</strong> 

                        <p className="eula-p">
                            This Agreement is effective until terminated. The Company may suspend or terminate your access to the platform at any time for violation of this Agreement or if we discontinue the service. Upon termination, your right to use the platform will immediately cease.
                        </p>
                </li>

                 <li>
                    
                       <strong className="eula-li">DISCLAIMER OF WARRANTIES</strong> 

                        <p className="eula-p">
                            The platform is provided "as is" and "as available." We do not warrant that the platform will be error-free, uninterrupted, or secure. To the fullest extent permitted by law, we disclaim all warranties, express or implied, including fitness for a particular purpose and non-infringement.
                        </p>
                </li>

                <li>
                    
                       <strong className="eula-li">LIMITATION OF LIABILITY</strong> 

                        <p className="eula-p">
                            To the extent permitted by applicable law, the Company shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of data, profits, or use, arising from your use of the platform.
                        </p>
                </li>

                 <li>
                    
                       <strong className="eula-li">GOVERNING LAW</strong> 

                        <p className="eula-p">
                            This Agreement shall be governed by and construed in accordance with the laws of Nova Scotia, Canada, without regard to conflict of laws principles.
                        </p>
                </li>

                <li>
                    
                       <strong className="eula-li">CHANGES TO THE AGREEMENT</strong> 

                        <p className="eula-p">
                           We may update this Agreement from time to time. If we make material changes, we will notify you via email or through the platform. Your continued use after the changes become effective constitutes your acceptance of the revised Agreement.
                        </p>
                </li>
             
            </ol>

            <p className="eula-p">
                Should you have any questions concerning this EULA, or if you desire to contact Designite for any reason, please contact us directly at:  <a className="eula-link" href="mailto:contact@designite-tools.com">contact@designite-tools.com</a>.
            </p>
            
      </div>
   
    </section>
            <Footer />
        </div>
    )
}

export default EULA;